import { Switch as ASwitch } from '@ark-ui/solid/switch';
import { Show, splitProps } from 'solid-js';
import { cn } from 'tailwind-variants';
import { Field } from './field.tsx';
import type { ComponentProps, JSXElement } from 'solid-js';

export function ToggleSwitch(props: ComponentProps<typeof ASwitch.Root> & { reverse?: boolean }) {
	const [internal, spread] = splitProps(props, ['reverse', 'class']);

	return (
		<Field name={props.name ?? ''}>
			<ASwitch.Root
				{...spread}
				class={cn(cn('relative flex items-start gap-2', internal.reverse && 'flex-row-reverse'), internal.class)}
			>
				<div class="relative h-6 w-10">
					<ASwitch.HiddenInput class="peer" />
					<ASwitch.Control class="relative top-0.5 block h-6 w-10 rounded-full bg-zinc-300 shadow-inner transition-colors duration-150 peer-checked:bg-yellow-500 peer-disabled:bg-zinc-200 motion-safe:peer-disabled:active:animate-shake dark:bg-zinc-600 dark:peer-disabled:bg-zinc-400" />
					<ASwitch.Thumb class="absolute inset-x-2.5 top-1 size-5 -translate-x-2 rounded-full bg-zinc-100 shadow transition-all duration-200 peer-checked:translate-x-2 peer-focus-visible:ring-4 peer-focus-visible:ring-yellow-500/50 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-zinc-50 peer-active:scale-90 peer-disabled:bg-zinc-100 peer-active:peer-disabled:animate-shake dark:peer-focus-visible:ring-offset-zinc-950" />
				</div>
				<div class={internal.reverse ? 'grow text-start' : ''}>{props.children}</div>
			</ASwitch.Root>
		</Field>
	);
}

ToggleSwitch.Label = (props: ComponentProps<typeof ASwitch.Label>) => (
	<ASwitch.Label {...props} class={cn('text-lg font-medium', props.class)} />
);

export function ToggleSwitchField(
	props: ComponentProps<typeof ToggleSwitch> & { name: string; label: JSXElement; description?: JSXElement },
) {
	const [other, rest] = splitProps(props, ['label', 'description']);
	return (
		<ToggleSwitch {...rest}>
			<ToggleSwitch.Label>{other.label}</ToggleSwitch.Label>
			<Field.Errors />
			<Show when={other.description}>{(desc) => <Field.Description>{desc()}</Field.Description>}</Show>
		</ToggleSwitch>
	);
}
